/** Pixen Intrigue — English overrides for the guided Play Now demo. Courtly-fae voice.
 *  Only keys whose shared-shell value carried Grymwyrd flavor are overridden here — the demo's underlying
 *  mechanics (SRD 5.2.1 ability scores, initiative) are shared by every world and stay unchanged. */
export const demoPixEn = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Play Now — Enter the Court',
  'demo.seoDescription':
    'Spin the world, claim a seat at the table, forge a Pixen Intrigue courtier, and roll the bones — a guided tour of the Pixen Intrigue virtual tabletop.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'The world of Pixen Intrigue',
  'demo.globe.tagline': 'A faerie-court intrigue world',
  'demo.globe.heading': 'Find your place in the Court',
  'demo.globe.subheading': 'A table waits behind the glamour. Take your seat and forge a courtier.',
  'demo.globe.enterCta': 'Enter Pixen Intrigue',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.subheading':
    "Create a free account to unlock the full Pixen Intrigue archive and save the courtier you're about to forge — or step through as a guest and explore now.",

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.lobbyEyebrow': 'Pixen Intrigue Virtual Tabletop · Lobby',
  'demo.create.heading': 'Forge your courtier',
  'demo.create.subheading': 'An SRD 5.2.1 character, born of the Court. Name them, choose a calling, and roll the bones.',
  'demo.create.namePlaceholder': 'Who do they become behind the mask?',
  'demo.create.keepStandard': 'Or keep the standard 10s and enter the Court.',
  'demo.create.initiativeResult': 'Initiative {initiative} — roll the bones, the Court turns to you…',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.initiativePrompt': 'Roll the bones to see who speaks first when the masks come off.',
  'demo.table.vttEyebrow': 'Pixen Intrigue VTT',
  'demo.table.saveHeroTitle': 'Create a free account to save your courtier',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.tagline': "Your table's intrigue, once the masks come off.",

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.searchPlaceholder': 'Look up a rival, a favor, a rule…',
  'demo.reference.typeToSearch': 'Type at least two letters to search the Court archive.',
  'demo.reference.notOwned':
    "You don't own this book yet. The full reference unlocks once you add it to your library.",

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.tagline': 'Walk back through the intrigue, whisper by whisper.',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.classLevel': '{className} · Season 1',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.body':
    "You're in the middle of a game. This is a guest table — if you leave now, the session ends and your courtier is lost to the Court.",
}
